<template>
    <a-modal
        :visible="visible"
        title="Else Aksiyonları Düzenle"
        width="800px"
        :footer="null"
        @cancel="onCancel"
        :bodyStyle="{ padding: '24px' }"
    >
        <div class="else-actions-editor">
            <p class="info-text">
                Hiçbir kural eşleşmediğinde çalışacak aksiyonları tanımlayın
            </p>

            <ActionsEditor
                v-model="localActions"
                when-type="else"
                :workflow-id="workflowId"
            />

            <div class="footer-actions">
                <a-button @click="onCancel">
                    İptal
                </a-button>
                <a-button type="primary" @click="onSave">
                    Kaydet
                </a-button>
            </div>
        </div>
    </a-modal>
</template>

<script>
import ActionsEditor from "./ActionsEditor.vue";
import _ from "lodash";

export default {
    name: "ElseActionsEditor",
    components: {
        ActionsEditor
    },
    props: {
        visible: {
            type: Boolean,
            required: true
        },
        actions: {
            type: Array,
            default: () => []
        },
        workflowId: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            localActions: []
        };
    },
    watch: {
        visible(newVal) {
            if (newVal) {
                this.localActions = _.cloneDeep(this.actions);
            }
        }
    },
    created() {
        this.localActions = _.cloneDeep(this.actions);
    },
    methods: {
        onCancel() {
            this.$emit("close");
        },

        onSave() {
            this.$emit("save", this.localActions);
        }
    }
};
</script>

<style lang="scss" scoped>
.else-actions-editor {
    .info-text {
        color: #666;
        font-size: 14px;
        margin-bottom: 24px;
        padding: 12px;
        background: #f5f5f5;
        border-radius: 6px;
    }

    .footer-actions {
        display: flex;
        justify-content: flex-end;
        gap: 12px;
        margin-top: 24px;
        padding-top: 24px;
        border-top: 1px solid #f0f0f0;
    }
}
</style>
